import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { _3_DAYS } from "../../../constants/durations";
import { useSpace } from "../../../hooks/useSpace";
import { OpenTaskWithSubTopic } from "../../../types";
import { keys } from "./keys";

async function fetchOpenTasks(spaceId: string): Promise<OpenTaskWithSubTopic[]> {
  const { data, error } = await apiClient
    .from('subject_tasks')
    .select('*, sub_topics!inner(id, name, topics!inner(space_id))')
    .eq('state', 'pending')
    .eq('sub_topics.topics.space_id', spaceId)
    .order('created_at', { ascending: true });

  if (error) {
    throw error;
  }

  return (data ?? []) as unknown as OpenTaskWithSubTopic[];
}

export function useGetOpenTasks() {
  const { currentSpace } = useSpace();

  return useQuery({
    queryKey: keys.openTasks(currentSpace?.id ?? ''),
    queryFn: () => fetchOpenTasks(currentSpace!.id),
    enabled: !!currentSpace?.id,
    staleTime: _3_DAYS,
  });
}
